import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useStudent } from "../context/StudentContext";
import { buildStudentTabHref } from "../utils/studentSidebarNavigation";
import { isCoursePestanaNavActive } from "../utils/coursePestanaNavActive";
import { listPublishedCourseTabs } from "../utils/normalizeCourseShape";
import "./CoursePestanasNav.css";

/**
 * Shared course tab strip for campus, tests and other student course views.
 */
function CoursePestanasNav({ previewMode = false, activePestana = "", onSelectPestana = null }) {
  const { activeCourse, activeCourseTabHints, activeCourseNavigation } = useStudent();
  const location = useLocation();
  const pestanas = listPublishedCourseTabs(
    activeCourseNavigation?.pestanasCurso?.length
      ? activeCourseNavigation.pestanasCurso
      : activeCourse?.pestanasCurso,
    activeCourseNavigation?.contenido,
  );

  if (pestanas.length === 0) {
    return null;
  }

  if (previewMode) {
    return (
      <nav className="campus-course-tabs" aria-label="Pestañas del curso">
        {pestanas.map((pestana) => {
          const isActive = pestana === activePestana;
          return (
            <button
              key={pestana}
              type="button"
              className={`campus-course-tab${isActive ? " active" : ""}`}
              aria-current={isActive ? "page" : undefined}
              onClick={() => onSelectPestana?.(pestana)}
            >
              {pestana}
            </button>
          );
        })}
      </nav>
    );
  }

  return (
    <nav className="campus-course-tabs" aria-label="Pestañas del curso">
      {pestanas.map((pestana) => {
        const href = buildStudentTabHref(pestana, activeCourseTabHints);
        const isActive = isCoursePestanaNavActive(
          location.pathname,
          location.search,
          pestana,
          activeCourseTabHints,
        );
        return (
          <Link
            key={pestana}
            to={href}
            className={`campus-course-tab${isActive ? " active" : ""}`}
            aria-current={isActive ? "page" : undefined}
          >
            {pestana}
          </Link>
        );
      })}
    </nav>
  );
}

export default CoursePestanasNav;
